<template>
    <div :class="cn('relative rounded-md bg-[#f5f5f5] dark:bg-[#202226] mt-[5px] transition-transform hover:translate-y-[-5px] py-8 px-4', $attrs.class!)" v-bind="$attrs">
        <NuxtImg class="mx-auto object-contain h-24" :src="icon" :alt="name" loading="lazy" />
        <h2 class="mt-6 font-bold text-center text-gray-800 dark:text-white truncate">{{ name }}</h2>
        <div class="text-center">
            <p class="dark:text-white text-[13px] font-semibold">{{ $dayjs(date).fromNow() }}</p>
            <ShadBadge class="mt-3" :variant="released ? 'success' : 'destructive'">{{ released ? 'Released' : 'Unreleased '}}</ShadBadge>
        </div>
    </div>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils'

defineProps({
    icon: {
        type: String,
        required: true,
    },
    name: {
        type: String,
        required: true
    },
    released: Boolean,
    date: String
})

defineOptions({
    inheritAttrs: false
})
</script>